import { SecurityFormHeader } from './components/Header/SecurityFormHeader';
import { TwoStepAuthentication } from './components/TwoStepAuthentication/TwoStepAuthentication';

export const SecurityForm = () => (
    <div className="mt-2xl">
        <SecurityFormHeader />
        <TwoStepAuthentication />
    </div>
);
